import {
	INPUT_ABOUT,
	GET_ABOUT
} from './Types';

export const inputAbout = txt => { return { type: INPUT_ABOUT, payload: txt } };
export const getAbout = () => { return { type: GET_ABOUT } };


// WEBPACK FOOTER //
// ./src/actions/AboutActions.js